import React from "react";
import { Box } from "@mui/material";
import { connectStats } from "react-instantsearch-dom";

type StatsProps = {
  nbHits: number;
};

const Stats: React.FunctionComponent<any> = (props): JSX.Element => {
  const { nbHits }: StatsProps = props;

  const hasResults = nbHits > 0;

  return (
    <Box aria-live="polite" role="status">
      {hasResults ? (
        <>
          <span style={{ fontWeight: 600 }}>{nbHits}</span> {nbHits === 1 ? "sökträff" : "sökträffar"}
        </>
      ) : (
        <>
          <span style={{ fontWeight: 600 }}></span> Din sökning gav inga träffar
        </>
      )}
    </Box>
  );
};

export default connectStats(Stats);
